__turbopack_context__.v({
  "bestSellerRecommendations": "BestSellerRecommendations-module-scss-module__Owfc3G__bestSellerRecommendations",
});
